"use client";
import { motion } from "framer-motion";
import Image from "next/image";

interface CareerGalleryCardProps {
  src: string;
  height: string;
  alt: string;
  index: number;
}

const CareerGalleryCard = ({
  src,
  height,
  alt,
  index,
}: CareerGalleryCardProps) => {
  return (
    <motion.div
      initial={{ filter: "grayscale(100%)" }}
      whileInView={{ filter: "grayscale(0%)" }}
      viewport={{ once: false, amount: 0.8 }}
      transition={{
        duration: 1.5,
        delay: (index % 3) * 0.2,
        ease: [0.76, 0, 0.24, 1],
      }}
      className={`relative w-full ${height} overflow-hidden rounded-md group`}
    >
      <Image
        src={src}
        alt={alt}
        fill
        className="object-cover transition-transform duration-700 group-hover:scale-105"
        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
      />
      {/* Subtle overlay for depth */}
      <div className="absolute inset-0 bg-black/5 opacity-40 group-hover:opacity-0 transition-opacity" />
    </motion.div>
  );
};

export default CareerGalleryCard;
